module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1r9n7n4r-b732768ee4ea4bf8062138184f9694f9.svg";